import { ImageProps } from '@/components/base/image'
import {
  AnchorAttributes,
  AnchorProps,
  DivAttributes,
} from '@wap-client/constants'

export interface ISlideCardProps extends DivAttributes {
  title?: string
  desc?: string
  linkSrc?: string | AnchorProps
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>['target']
  image?: string | ImageProps
  sizes?: ISliceCardSizes
  shadow?: ISlideCardShadow
  isSustainable?: boolean
  isSocialShader?: boolean
  isHorizontal?: boolean
  brokenImage?: ImageProps
  eventName?: string
  moreEventName?: string
}

export interface IRouteLayoutProps extends AnchorAttributes {
  page?: string
  title?: string
  eventName?: string
  moreEventName?: string
}

export interface ISliceCardSizes {
  width: string
  height: string
}

export type ISlideCardShadow = 'bottom' | 'top' | 'left' | 'right' | 'all'

export enum ENUMSliderCardShadows {
  'bottom' = 'bottom-shadow',
  'top' = 'top-shadow',
  'left' = 'left-shadow',
  'right' = 'right-shadow',
  'all' = 'all-shadow',
}
